import { Moon, Sun } from 'lucide-react'
import { useTheme } from './ThemeProvider'
import './ThemeToggle.css'

/**
 * Two-way toggle: the opposite of whatever is on screen right now. System is a Settings choice —
 * flipping here pins Light or Dark so the click always does what the icon says.
 */
export default function ThemeToggle({
  className,
  compact = false,
}: {
  className?: string
  compact?: boolean
}) {
  const { effectiveTheme, setTheme } = useTheme()
  const isDark = effectiveTheme === 'dark'
  const next = isDark ? 'light' : 'dark'
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode'

  return (
    <button
      type="button"
      className={`theme-toggle${compact ? ' theme-toggle--compact' : ''}${className ? ` ${className}` : ''}`}
      onClick={() => setTheme(next)}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      data-analytics-event="theme-toggle"
    >
      {isDark ? <Sun size={16} strokeWidth={1.75} aria-hidden /> : <Moon size={16} strokeWidth={1.75} aria-hidden />}
      {!compact && <span>{isDark ? 'Light mode' : 'Dark mode'}</span>}
    </button>
  )
}
